import Colors from "Constants/Colors";

export const CustomStylesSubSystemOptions = {
  menu: (provided: any, state: any) => ({
    ...provided,
    width: state.selectProps.width,
    borderBottom: "1px dotted pink",
    color: state.selectProps.menuColor,
    padding: 10,
    backgroundColor: Colors.WHITE,
    zIndex: 9999,
    flexGrow: 0,
    flexShrink: 0,
  }),

  control: (_: any, { selectProps: { width } }: any) => ({
    backgroundColor: Colors.WHITE,
    minWidth: 200,
    borderColor: Colors.BLACK,
    minHeight: 40,
    borderRadius: 4,
    overflow: "hidden",
    flexGrow: "0 !important",
    flexShrink: "0 !important",
  }),

  singleValue: (provided: any, state: any) => {
    const transition = "opacity 300ms";
    return { ...provided, transition };
  },

  // The valueContainer will now be a flexbox with overflow management
  valueContainer: (provided) => ({
    ...provided,
    flexGrow: "0 !important",
    flexShrink: "0 !important",
    //flexWrap: 'nowrap',
    overflowX: "hidden",
    overflowY: "scroll",
    height: "40px",
    padding: "0 8px",
  }),

  // Styles for the individual selected items (chips)
  multiValue: (provided) => ({
    ...provided,
    maxWidth: "120px",
    overflow: "hidden",
    marginRight: "4px",
  }),

  // Styles for the text inside the chips
  multiValueLabel: (provided) => ({
    ...provided,
    overflow: "hidden",
    //textOverflow: 'ellipsis',
    whiteSpace: "nowrap",
  }),
};
